module.exports = __webpack_public_path__ + "files/guia_pratico_drconecta_2022.pdf";